import React, {useRef, useEffect} from "react";
import PropTypes from "prop-types";
import {makeStyles, Box, Dialog, DialogTitle, DialogContent, DialogActions, IconButton} from "@material-ui/core";
import {useBreakpoints} from "../../../hooks";
import CloseIcon from "../streamline-icon/CloseIcon";

const useStyles = makeStyles((theme) => ({
    title: {
        padding: theme.spacing(1.5, 2, 1.5, 3)
    },
    actions: {
        justifyContent: "center",
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(4)
    }
}));

const ResponsiveDialog = ({
    open,
    handleClose,
    disableBackdropClick,
    disableEscapeKeyDown,
    hasCloseButton,
    title,
    content,
    actions,
    ...props
}) => {
    const classes = useStyles();
    const {isExtraSmallScreen} = useBreakpoints();

    const dialogRef = useRef(null);
    const removeTabIndex = () => {
        dialogRef?.current?.getElementsByClassName("MuiDialog-container")[0].removeAttribute("tabindex");
    };

    useEffect(() => {
        setTimeout(removeTabIndex, 1000);
    }, []);

    return (
        <Dialog
            fullWidth
            fullScreen={isExtraSmallScreen()}
            open={open}
            onClose={handleClose}
            disableBackdropClick={disableBackdropClick}
            disableEscapeKeyDown={disableEscapeKeyDown}
            ref={dialogRef}
            {...props}
        >
            <DialogTitle className={classes.title}>
                <Box
                    display="flex"
                    alignItems="center"
                >
                    <Box flexGrow={1}>{title}</Box>
                    {hasCloseButton &&
                        <Box>
                            <IconButton onClick={handleClose}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    }
                </Box>
            </DialogTitle>
            <DialogContent>
                {content}
            </DialogContent>
            {actions &&
                <DialogActions className={classes.actions}>
                    {actions}
                </DialogActions>
            }
        </Dialog>
    );
};

ResponsiveDialog.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    disableBackdropClick: PropTypes.bool,
    disableEscapeKeyDown: PropTypes.bool,
    hasCloseButton: PropTypes.bool,
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.element
    ]),
    content: PropTypes.element,
    actions: PropTypes.element,
    props: PropTypes.any
};

export default ResponsiveDialog;
